module.exports = __webpack_public_path__ + "img/icon-help.778bd071.png";